import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../utils/i18n';
import './CookieBanner.css';

const STORAGE_KEY = 'pfm-cookie-consent-v1';

const CookieBanner = () => {
    const { lang, dir } = useLanguage();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(window.localStorage.getItem(STORAGE_KEY) !== 'accepted');
    }, []);

    const acceptCookies = () => {
        window.localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner" dir={dir} role="region" aria-label="Cookie notice">
            <div className="cookie-banner__content">
                <h2>{t({ en: 'Cookie notice', de: 'Cookie-Hinweis', fa: 'اطلاعیه کوکی' }, lang)}</h2>
                <p>
                    {t({
                        en: 'We use essential cookies and browser storage for login, sessions, security, language preferences, and Stripe payments. We do not sell personal data.',
                        de: 'Wir verwenden notwendige Cookies und Browser-Speicher fuer Anmeldung, Sitzungen, Sicherheit, Spracheinstellungen und Stripe-Zahlungen. Wir verkaufen keine personenbezogenen Daten.',
                        fa: 'ما از کوکی‌ها و ذخیره‌سازی ضروری مرورگر برای ورود، نشست‌ها، امنیت، تنظیمات زبان و پرداخت‌های Stripe استفاده می‌کنیم. ما داده‌های شخصی را نمی‌فروشیم.',
                    }, lang)}
                </p>
            </div>
            <div className="cookie-banner__actions">
                <Link to="/policy#privacy" className="cookie-banner__link">
                    {t({ en: 'Privacy Policy', de: 'Datenschutz', fa: 'حریم خصوصی' }, lang)}
                </Link>
                <button type="button" className="cookie-banner__button" onClick={acceptCookies}>
                    {t({ en: 'Accept', de: 'Akzeptieren', fa: 'می‌پذیرم' }, lang)}
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
